import upperFirst from "mn-utils/upperFirst";
import toLower from "mn-utils/toLower";
import parseCryptoToken from "../../../../../../../utils/parseCryptoToken";
import {pushLocation} from "../../../../../../../router";
import {LINK_TRANSACTION_DETAILS, LINK_TRANSACTION_REFUND} from "../../../../../../../constants/links";
import openPopupEdit from "../../../../Refund/openPopupEdit";
import generateReceipt from "./generateReceipt";

export const generateActionsList = (data, update) => {
  const KIND_REFUND = 'refund';
  const TRANSACTION_STATUS_COMPLETED = 'completed';

  const isStablecoin = !!data.sc_amount;
  const currencyAmount = isStablecoin ? data.sc_amount : data.fiat_amount;
  const currencyCode = isStablecoin ? data.sc_code : data.fiat_code;

  const cryptoCurrencyAmount = data.currency_amount;
  const cryptoCurrencyCode = data.currency_code;

  const transactionKind = upperFirst(data.transaction_kind || '').replace('_', ' ');
  const retailerName = data.retailer_name || '';
  const paymentId = data.payment_id || '';
  const orderId = data.order_id || '';
  const auctionId = data.auction_id || '';
  const refundId = data.refund_id || '';
  const email = data.email || '';
  const timeOfTransaction = data.date_time || '';
  const status = toLower(data.transaction_status || '');

  const parsedCryptoToken = parseCryptoToken(data.currency_code || '-');
  const network = data.network || parsedCryptoToken[0];
  const feeCode = data.sc_fee_code ? data.sc_fee_code : data.fiat_fee_code;
  const retailerFeeAmount = data.retailer_fee_amount;
  const customerFeeAmount = data.customer_fee_amount;
  const hash = data.hash;

  const canBeRefunded = status === TRANSACTION_STATUS_COMPLETED
    && data.transaction_kind !== KIND_REFUND
    && !isStablecoin
    && cryptoCurrencyCode !== 'KLUB';


  return [
    {
      name: 'Details', onClick() {
        pushLocation({
          path: `${LINK_TRANSACTION_DETAILS}/${orderId}/${paymentId}/${auctionId}/${refundId}`,
        });
      },
    },
    ...(data.transaction_kind === KIND_REFUND && status === 'requested' && !isStablecoin ? [
      {
        name: 'Edit', onClick() {
          openPopupEdit(data, update);
        },
      },
    ] : []),
    {
      name: 'Receipt', onClick() {
        generateReceipt({
          transactionKind,
          retailerName,
          paymentId,
          currencyTitle: `Amount (${data.sc_amount ? 'stablecoin' : 'fiat'})`,
          currencyAmount,
          currencyCode,
          cryptoCurrencyAmount,
          cryptoCurrencyCode,
          network,
          feeCode,
          retailerFeeAmount,
          customerFeeAmount,
          timeOfTransaction,
          hash,
          email,
          status,
        });
      },
    },
    ...(canBeRefunded ? [
      {
        name: 'Refund', onClick() {
          pushLocation({
            path: `${LINK_TRANSACTION_REFUND}/${orderId}/${paymentId}`,
          });
        },
      },
    ] : [])
  ];
}
